import Analytics from './service/analytics';
import Repository from './service/repository';
import Storage from './service/storage';

const repository = new Repository();
const storage = new Storage();
const analytics = new Analytics();

export { repository, analytics, storage };
